import { API } from '@shared/types/api';
import { createCtx } from '@shared/util/context';
import {
  CardPaginationQuery,
  CardPaginationQueryState,
  CardPaginationQueryStateWithCards,
} from './types';

interface State {
  stateByQuery: { [jsonStringifiedQuery: string]: CardPaginationQueryState };
  cardById: { [cardId: string]: API.CardFragment };
}

export interface ActionsContext {
  fetchMore(
    query: CardPaginationQuery,
    reset?: boolean,
  ): Promise<CardPaginationQueryStateWithCards | undefined>;
  addCard(card: API.CardFragment, batch?: boolean): void;
  updateCard(card: API.CardFragment, batch?: boolean): void;
  removeCard(cardId: string, batch?: boolean): void;
}

export interface StateContext {
  state: State;
  getState(query: CardPaginationQuery): CardPaginationQueryStateWithCards | undefined;
  getCard(id: string): API.CardFragment;
}

export const [useCardPaginationState, CardPaginationStateContextProvider] =
  createCtx<StateContext>();

export const [useCardPaginationActions, CardPaginationActionsContextProvider] =
  createCtx<ActionsContext>();
